
import React from 'react';
import type { Feature } from '../types.ts';

export const Placeholder: React.FC<{ feature?: Feature }> = ({ feature }) => {
    return (
        <div className="flex flex-col items-center justify-center h-full p-8 text-center text-slate-400">
            <div className="text-6xl mb-4" aria-hidden="true">
                {feature?.icon}
            </div>
            <h1 className="text-3xl font-bold text-slate-200 mb-2">
                {feature?.name || 'Feature'}
            </h1>
            <p className="text-lg mb-4 max-w-md">
                {feature?.description || 'Feature description.'}
            </p>
            <div className="bg-yellow-900/50 text-yellow-300 border border-yellow-800/80 rounded-lg px-6 py-3">
                <p className="font-semibold">Under Construction</p>
                <p className="text-sm">This feature is not yet available.</p>
            </div>
        </div>
    );
};